export interface ILabelFormatSettingsForm {
  saveAsDefault: boolean;
}
